import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./projectQuote.scss";
import "./QuoteTable.scss";
import "./DialogQuote.scss";
import { NavLink, Redirect } from "react-router-dom"; //make sure to import all the components.
import Axios from "axios-https-proxy-fix";
import * as actionTypes from "../../store/actions";
import DialogFollowup from "./DialogFollowup/DialogFollowup";
import DialogEmailQuote from "./DialogEmailQuote/DialogEmailQuote";
import DialogEmailSpecList from "./DialogEmailSpecList/DialogEmailSpecList";
import DialogEmailPictureBook from "./DialogEmailPictureBook/DialogEmailPictureBook";
import DialogTransferOrder from "./DialogTransferOrder/DialogTransferOrder";
import PrintForm from "./PrintForm/PrintForm";
import DialogDelete from "./DialogDelete/DialogDelete";
import DialogProductDetails from "./DialogProductDetails/DialogProductDetails2";
import Toggle from "react-toggle";
import "./Toggle.scss";
import { toast } from "react-toastify";
// dependencies for loading dialog
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import ReactLoader from "react-loader-spinner";
// Components used to create the dialog
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Translated from "../../components/Translated/Translated";
import translator from "../../utils/translator";
import checkSettings from "../../utils/checkSettings";
import api from "../../utils/api";
import {displayError} from "../../utils/toastHelper";

export class ProjectQuote extends Component {
	static propTypes = {
		prop: PropTypes
	};

	state = {
		rooms: {},
		products: {},
		deletions: {},
		delete_dialog: 0,
		options: {
			active: false,
			isPercent: false,
			value: 0.0,
			changed: 0,
			input: {
				isPercent: false,
				value: 0.0
			}
		},
		quote_id: 0,
		project_allowance: 0,
		margin: 0,
		margin_type: 1,
		productDetailsDialog: null,
		// we use this when loading the page and when moving a product to another room. It takes a while to load up
		loading: false,

		// These two states are for getting the list of products for a room
		// we modify these states in the loop that happens in the render of this component
		// it's constantly changing and holds one value
		productID: null,
		rooms_v2: [],
		is_rooms_hidden: false, // This is used for the hide_all_rooms function. By default all rooms are showing. This way the program knows when to display all or hide all.
		dialog: null,
		transferred: false,
		notInWarehouseProduct: false,
		userFiles: null,
	};

	inputNumberBlockedChars = ['e', 'E', '+', '-'];
	inputQtyBlockedChars = ['e', 'E', '+', '-', '.'];

	transferSuccess = () => {
		this.setState({ transferred: true });
	};

	checkNumber = value => {
		value = parseFloat(value);
		return value >= 0 || value <= 0;
	};

	checkIfBlockedChar = (event, input = "price") => {
		if(input === "qty" && this.inputQtyBlockedChars.includes(event.key)) {
			event.preventDefault();
		} else if(input === "price" && this.inputNumberBlockedChars.includes(event.key)) {
			event.preventDefault();
		}
	};

	roundNumber = value => {
		if (!value) return 0;
		return parseFloat(parseFloat(value).toFixed(2));
	};

	getProductPrice = item => {
		// Use the manual price if it exists
		if (this.checkNumber(item.manual_price)) {
			return this.roundNumber(item.manual_price, 2);
		}
		// Use non-stock price if exists
		if (this.checkNumber(item.non_stock_price)) {
			return this.roundNumber(item.non_stock_price, 2);
		}
		// If acting agent, apply margins
		// NOTE: Does not yet handle margin_type 3: alt pricing account
		if (this.props.actingAgent) {
			let price = parseFloat(item.price);
			let margin = price * this.state.margin;
			if (this.state.margin_type === 2) margin *= -1;
			return this.roundNumber(price + margin, 2);
		}

		// If not agent, use negotiations value if possible
		if (!this.props.actingAgent && this.checkNumber(item.extended_net)) {
			return this.roundNumber(item.extended_net, 2);
		}
		return this.roundNumber(item.price, 2);
	};

	getUnitTotal = id => {
		let item = this.state.products[id];
		if (item.info.is_standard) return 0;
		let price = Math.max(0, item.price - this.roundNumber(item.info.allowance_amount, 2));
		return price * item.quantity;
	};

	getRoomQuantity = roomID => {
		return this.state.rooms[roomID].products.reduce((sum, id) => {
			return sum + this.state.products[id].quantity;
		}, 0);
	};

	getRoomTotal = roomID => {
		return this.state.rooms[roomID].products.reduce((sum, id) => {
			return sum + this.getUnitTotal(id);
		}, 0.0);
	};

	getProjectQuantity = () => {
		return Object.keys(this.state.rooms).reduce((sum, id) => {
			return sum + this.getRoomQuantity(id);
		}, 0.0);
	};

	getMaterialTotal = () => {
		return Object.keys(this.state.rooms).reduce((sum, id) => {
			return sum + this.getRoomTotal(id);
		}, 0.0);
	};

	getProjectTotal = () => {
		let total = this.getMaterialTotal();
		let options = this.state.options;
		total = options.isPercent ? (total * (100 - options.value)) / 100.0 : total - options.value;
		return Math.max(0, total - this.state.project_allowance);
	};

	componentDidMount = async () => {
		if (!this.props.projectId) return; // State was lost, do not compute
		this.setProductsAndRooms();

		// This fixed the synchronous problem. Sometimes it will work sometimes it doesn't. This will make it consistent
		setTimeout(async () => {
			await this.props.displayCheckPricesButtonOnNavBar(true);
			await this.props.displayProductShoppingButtonOnNavBar(
				true,
				this.props.warehouse_number_for_product_shopping_nav_bar_test
			);
		}, 2000);
	};

	componentDidUpdate(prevProps) {
		if (prevProps.details_updated !== this.props.details_updated) {
			this.setProductsAndRooms();
		}
	  }

	fetchUserFiles = async () => {
        try {
            const data = await api.post(
                "/products/get-user-files",
                { projectId: this.props.projectId },
            );
            return data.products;
        } catch(error) {
			displayError(error, "Error fetching wishlist");
        }
    };

	setProductsAndRooms = async () => {
		this.setState({ loading: true });
		let ajaxURL = this.props.APIUrl + "/quote/fetch-quote-products";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			projectId: this.props.projectId
		};
		let APIResponse = await Axios.post(ajaxURL, data);
		let [rooms, products] = APIResponse.data.products.reduce(
			(arr, item) => {
				let [rooms, products] = arr;
				// Add Room
				if (!rooms.hasOwnProperty(item.room_id)) {
					rooms[item.room_id] = {
						title: item.room_title,
						products: [],
						sort_order: Object.keys(rooms).length,
						hide: 0
					};
				}
				// Add Product to Room
				rooms[item.room_id].products.push(item.record_id);
				// Add Product
				let price = this.getProductPrice(item);
				products[item.record_id] = {
					title_non_stock: item.non_stock_title,
					sku: !!item.SX_Prod_Id ? item.SX_Prod_Id : item.non_stock_model,
					quantity: item.quantity,
					price: price,
					sort_order: rooms[item.room_id].products.length,
					info: item,
					changed_price: 0,
					changed_quantity: 0,
					changed_description: 0,
					changed_note: 0,
					ex: !!item.manual_price || !!item.extended_net ? 1 : 0,
					nw: item.from_catalog ? true : false,
					input: {
						quantity: item.quantity,
						price: price,
						description: {
							en: item.non_stock_title || item?.info?.name?.en || item.EnglishDescription,
							fr: item.non_stock_title || item?.info?.name?.fr || item.FrenchDescription
						},
						note: item.note
					}
				};

				if(item.from_catalog && !this.state.notInWarehouseProduct) {
					this.setState({ notInWarehouseProduct: true });
				}

				return [rooms, products];
			},
			[{}, {}]
		);
		let quote = APIResponse.data.hasOwnProperty("quote")
			? APIResponse.data.quote
			: { id: 0, override_amount: 0, override_type: "" };
		let optionsValue = this.roundNumber(0 - parseFloat(quote.override_amount), 2);
		let options = {
			active: !!optionsValue,
			changed: 0,
			isPercent: quote.override_type === "percentage" ? true : false,
			value: optionsValue
		};
		options.input = {
			isPercent: options.isPercent,
			value: options.value
		};
		let project_allowance = this.roundNumber(APIResponse.data.project_allowance);
		let margin = this.roundNumber(APIResponse.data.accountInfo.margin);
		let margin_type = APIResponse.data.accountInfo.pricing_type_id;

		// ============

		let sortedResponse = await Axios.post(this.props.APIUrl + "/room/get-quote-order", {
			project_id: this.props.projectId
		});
		let rooms_v2 = sortedResponse.data.sorted;

		const userFiles = await this.fetchUserFiles();

		await this.setState({
			options: options,
			rooms: rooms, // I realized if i don't use this I have to refactor A LOT OF CODE just to fix this small problem which is the order of the rooms are showing correctly based on how you sorted it in project set up page
			rooms_v2: rooms_v2,
			products: products,
			quote_id: quote.id,
			project_allowance: project_allowance,
			margin: margin,
			margin_type: margin_type,
			loading: false,
			userFiles,
		});
		return APIResponse.data;
	};

	toggleNotInWarehouseStatus = async (updatedProducts) => {
		// Get current product state to update
		let currentProducts = {...this.state.products};

		for(let key in this.state.products) {
			let product = this.state.products[key];
			// Compare updates against current state products
			let productFoundAndUpdated = updatedProducts.some(el => product.sku === el.sku);
			
			// If the sku was updated (found in updatedProducts) update its catalog/nw status
			if(!!productFoundAndUpdated) {
				currentProducts[key].nw = false
			}
		}
		// Set once to avoid re-renders!
		this.setState({ products: currentProducts });
	}

	// EVENT HANDLERS

	hideRoom = e => {
		let id = e.target.parentNode.parentNode.getAttribute("data-id");
		this.setState(state => ({
			rooms: {
				...state.rooms,
				[id]: {
					...state.rooms[id],
					hide: state.rooms[id].hide ? 0 : 1
				}
			}
		}));
	};

	hide_all_rooms = e => {
		let rooms_state_keys = Object.keys(this.state.rooms); // Rooms is not an array. it's an object with a list of keys/properties that are object its self.
		let rooms = this.state.rooms;

		if (this.state.is_rooms_hidden) {
			for (let room_state_key of rooms_state_keys) {
				rooms[room_state_key].hide = 0;
			}
			this.setState({ rooms, is_rooms_hidden: false });
		} else {
			for (let room_state_key of rooms_state_keys) {
				rooms[room_state_key].hide = 1;
			}
			this.setState({ rooms, is_rooms_hidden: true });
		}
	};

	toggleDelete = e => {
		let id = e.target.parentNode.parentNode.getAttribute("data-id");
		let deletions = this.state.deletions;
		if (deletions.hasOwnProperty(id)) {
			delete deletions[id];
		} else {
			deletions[id] = this.state.products[id].info.wishlist_id;
		}
		this.setState(state => ({
			deletions: deletions
		}));
	};

	deleteRows = e => {
		let deletions = this.state.deletions;
		let rooms = this.state.rooms;
		let rooms_v2 = this.state.rooms_v2;
		let products = this.state.products;

		Object.keys(rooms).map(roomID => {
			rooms[roomID].products = rooms[roomID].products.filter(
				id => !Object.keys(deletions).includes("" + id)
			);
		});

		rooms_v2 = rooms_v2.map(room => {
			room.products = room.products.filter(id => !Object.keys(deletions).includes("" + id));
			return room;
		});

		Object.keys(deletions).map(id => {
			delete products[id];
		});

		this.setState(state => ({
			rooms: rooms,
			rooms_v2: rooms_v2,
			products: products
		}));
	};

	changeOptions = e => {
		let key = e.target.getAttribute("data-key");
		let value = key === "value" ? e.target.value : !this.state.options.input.isPercent;

		this.setState(state => ({
			options: {
				...state.options,
				changed: 1,
				input: {
					...state.options.input,
					[key]: value
				}
			}
		}));
	};

	saveOptions = async () => {
		let options = this.state.options;
		let roundValue = this.roundNumber(options.input.value, 2);
		if (options.input.isPercent && roundValue > 100) {
			let dialog_content = (
				<Dialog open={true} aria-labelledby="form-dialog-title">
					<DialogTitle>{translator("Misc", "error")}</DialogTitle>
					<DialogContent>
						<Translated section="Misc" label="adjustement_percentage_total_error" />.
					</DialogContent>
					<button
						onClick={() => this.setState({ dialog: null })}
						type="button"
						class="btn btn-primary set-price-confirm-button"
					>
						<Translated section="Misc" label="ok_btn" />
					</button>
				</Dialog>
			);

			await this.setState({
				dialog: dialog_content
			});
		} else {
			let ajaxURL = this.props.APIUrl + "/emco_quotes/update-options";
			let data = {
				trendId: localStorage.getItem("trendId"),
				token: localStorage.getItem("token"),
				project_id: this.props.projectId,
				quote_id: this.state.quote_id,
				total: this.getMaterialTotal(),
				value: roundValue,
				isPercent: options.input.isPercent
			};
			let APIResponse = await Axios.post(ajaxURL, data);
			if (APIResponse.data.hasOwnProperty("error")) {
				alert(APIResponse.data.error);
				return;
			}

			this.setState(state => ({
				options: {
					...state.options,
					isPercent: options.input.isPercent,
					value: roundValue,
					changed: 0,
					input: {
						...state.options.input,
						value: roundValue
					}
				}
			}));
		}
	};

	clearOptions = async () => {
		this.setState(
			state => ({
				options: {
					...state.options,
					changed: 1,
					input: {
						...state.options.input,
						value: 0
					}
				}
			}),
			this.saveOptions
		);
	};

	changeDescription = e => {
		let id = e.target.parentNode.parentNode.parentNode.parentNode.getAttribute("data-id");
		let value = e.target.value;

		this.setState(state => ({
			products: {
				...state.products,
				[id]: {
					...state.products[id],
					changed_description: 1,
					input: {
						...state.products[id].input,
						description: {
							...state.products[id].input.description,
							[this.props.selected_language]: value
						}
					}
				}
			}
		}));
	};

	changeNote = e => {
		let id = e.target.parentNode.parentNode.getAttribute("data-id");
		let value = e.target.value;

		this.setState(state => ({
			products: {
				...state.products,
				[id]: {
					...state.products[id],
					changed_note: 1,
					input: {
						...state.products[id].input,
						note: value
					}
				}
			}
		}));
	};

	changeQuantity = e => {
		let id = e.target.parentNode.parentNode.getAttribute("data-id");
		let value = e.target.value;

		this.setState(state => ({
			products: {
				...state.products,
				[id]: {
					...state.products[id],
					changed_quantity: 1,
					input: {
						...state.products[id].input,
						quantity: value
					}
				}
			}
		}));
	};

	changePrice = e => {
		let sku = e.target.parentNode.parentNode.getAttribute("data-sku");
		let value = e.target.value;

		this.setState(state => ({
			products: this.objectMap(state.products, product =>
				(!!product.sku && sku === product.sku) ||
				(!!product.info.non_stock_model && sku === product.info.non_stock_model)
					? {
							...product,
							changed_price: 1,
							input: {
								...product.input,
								price: value
							}
					  }
					: product
			)
		}));
	};

	updateUserFile = (sku, field, file) => {
        const skuFileMap = this.state.userFiles[sku] ? this.state.userFiles[sku] : {};
		this.setState((state) => ({
			userFiles: {
				...this.state.userFiles,
				[sku]: {
					...skuFileMap,
					[field]: file,
				},
			}
		}));
    };

	objectMap = (inputObject, func) => {
		return Object.fromEntries(
			Object.entries(inputObject).map(keyval => {
				return [keyval[0], func(keyval[1], keyval[0])];
			})
		);
	};

	saveProduct = async e => {
		let id = e.target.parentNode.parentNode.getAttribute("data-id");
		let item = this.state.products[id];
		let roundPrice = this.roundNumber(item.input.price, 2);
		let roundQuantity = parseInt(item.input.quantity);
		let input_description = item.input.description;
		let input_note = item.input.note;

		let toast_config = {
			position: "bottom-center",
			autoClose: false,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true
		};

		if(input_description[this.props.selected_language] === '') {
			return toast.error(translator("Misc", "product_title_not_present"), { ...toast_config, autoClose: true });
		}

		if(roundQuantity <= 0 || item.input.quantity === '') {
			return toast.error(translator("Misc", "quantity_invalid"), { ...toast_config, autoClose: true });
		}

		if(roundPrice < 0 || item.input.price === '' || roundPrice > 100000000) {
			return toast.error(translator("Misc", "price_invalid"), { ...toast_config, autoClose: true });
		}

		let loadingToast = toast.info("Saving...", toast_config);

		let credentials = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			project_id: this.props.projectId,
			quote_id: this.state.quote_id
		};

		if (item.changed_price) {
			let products = Object.entries(this.state.products)
				.filter(
					prod_arr =>
						prod_arr[1].changed_price &&
						((!!prod_arr[1].sku && item.sku === prod_arr[1].sku) ||
							(!!prod_arr[1].info.non_stock_model &&
								item.info.non_stock_model === prod_arr[1].info.non_stock_model))
				)
				.map(prod_arr => ({ id: prod_arr[0], price: roundPrice, non_stock: prod_arr[1].info["non-stock"] }));
			let response = await Axios.post(
				this.props.APIUrl + "/quote/update-same-product-prices",
				{ ...credentials, products: products }
			);
			if (response.data.hasOwnProperty("error")) {
				toast.dismiss(loadingToast);
				return toast.error(response.data.error, { ...toast_config, autoClose: true });
			}
		}

		if (item.changed_quantity) {
			if (parseInt(roundQuantity) === 0) {
				let data = { ...credentials, products: [id] };
				if (!!item.info.SX_Prod_Id) {
					data.wishlistIds = [item.info.wishlist_id];
				}
				let response = await Axios.post(
					this.props.APIUrl + "/emco_quotes/delete-products",
					data
				);
				if (response.data.hasOwnProperty("error")) {
					toast.dismiss(loadingToast);
					return toast.error(response.data.error, toast_config);
				}
			} else {
				let response = await Axios.post(
					this.props.APIUrl + "/quote/update-product-quantity",
					{
						...credentials,
						id: id,
						quantity: roundQuantity
					}
				);
				if (response.data.hasOwnProperty("error")) {
					toast.dismiss(loadingToast);
					return toast.error(response.data.error, toast_config);
				}
			}
		}

		if (item.changed_description) {
			let response = await Axios.post(
				this.props.APIUrl + "/quote/update-product-description",
				{
					...credentials,
					id: id,
					wishlist_id: item.info.id || null,
					description: input_description
				}
			);
			if (response.data.hasOwnProperty("error")) {
				toast.dismiss(loadingToast);
				return toast.error(response.data.error, toast_config);
			}
		}

		if (item.changed_note) {
			let response = await Axios.post(
				this.props.APIUrl + "/quote/update-product-note",
				{
					...credentials,
					id: id,
					wishlist_id: item.info.id,
					note: input_note
				}
			);
			if (response.data.hasOwnProperty("error")) {
				toast.dismiss(loadingToast);
				return toast.error(response.data.error, toast_config);
			}
		}

		toast.dismiss(loadingToast);

		toast.success(translator("Misc", "update_success"), { ...toast_config, autoClose: 2000 });

		let newDeletions = parseInt(roundQuantity) === 0 ? { [id]: item.info.SX_Prod_Id } : {};

		this.setState(
			state => ({
				deletions: {
					...state.deletions,
					...newDeletions
				},
				products: this.objectMap(state.products, (product, p_id) => {
					if (id === p_id) {
						product.quantity = roundQuantity;
						product.changed_quantity = 0;
						product.input.quantity = roundQuantity;
						product.changed_description = 0;
						product.changed_note = 0;
					}
					if (item.sku === product.sku) {
						product.price = roundPrice;
						product.ex = product.changed_price ? 1 : product.ex;
						product.changed_price = 0;
						product.input.price = roundPrice;
					}
					return product;
				})
			}),
			parseInt(roundQuantity) === 0 ? this.deleteRows : null
		);
	};

	updateOptionsButton = () => {
		return (
			<button class="quote-table-update-button" onClick={this.saveOptions}>
				<Translated section="Quote" label="update_btn" />
			</button>
		);
	};

	updateProductButton = productID => {
		return (
			<button
				class="quote-table-update-button"
				onClick={e => {
					this.saveProduct(productID);
				}}
			>
				<Translated section="Quote" label="update_btn" />
			</button>
		);
	};

	// This function is a master piece. It's a piece of art. It looks good lol
	rearrangeProducts = async result => {
		if(!!result.destination) {
			// Dragged to same room => change product order in room
			if (result.destination.droppableId === result.source.droppableId) {
				// Get a copy of products array in room
				let products = this.state.rooms_v2.reduce(
					(products, room) =>
						room.id === result.source.droppableId ? room.products.slice(0) : products,
					[]
				);

				// Move product to new index
				let [moved_product] = products.splice(result.source.index, 1);
				products.splice(result.destination.index, 0, moved_product);

				// Save new array of products in room to state
				this.setState(state => ({
					...state,
					rooms_v2: state.rooms_v2.map(room =>
						room.id === result.source.droppableId ? { ...room, products: products } : room
					)
				}));

				// Save product move to database
				let sort_api_url = this.props.APIUrl + "/room/sort-room-products";
				let data = {
					room_product_ids: products
				};
				await Axios.post(sort_api_url, data);

				return;

				// Dragged to diffeerent room => add product to room
			} else {
				let product = this.state.products[result.draggableId];

				let data = {
					room_id: result.destination.droppableId,
					room_product_id: result.draggableId,
					product_id: product.info.wishlist_id,
					non_stock_title: product.non_stock_title,
					non_stock_model: product.non_stock_model
				};

				let copy_product_api_url = this.props.APIUrl + "/room/copy-room-product";
				await Axios.post(copy_product_api_url, data);

				this.setProductsAndRooms();
			}
			return;
		}
	};

	render() {
		let priceFormat = new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: "USD" // if CAD is used, appends the string CA to price
		});

		if (!this.props.projectId) {
			// State was lost, redirect
			// I'm using this to redirect the user if they refresh the page because if they do that they will get an error due to all the states being erased. remember this is a single page application and was not meant to be refreshed.
			return <Redirect to="/search-projects" />;
		}

		let state = this.state; // Grab instance of state to be consistent
		let optionsClass = "quote-table-options";
		if (state.options.changed) optionsClass += " row-changed";

		let transferRedirect = state.transferred ? (
			<Redirect to={"/project-summary/" + this.props.projectId} />
		) : (
			""
		);

		return (
			<div>
				{transferRedirect}
				{this.state.loading ? (
					<Dialog open={true} aria-labelledby="form-dialog-title">
						<DialogTitle id="form-dialog-title set-price-dialog-header">
							<Translated section="Misc" label="loading_label" />{" "}
						</DialogTitle>
						<DialogContent style={{ paddingRight: "10em" }}>
							<ReactLoader
								style={{ marginLeft: "8em" }}
								type="Oval"
								color="#00BFFF"
								height={50}
								width={50}
							/>
						</DialogContent>
					</Dialog>
				) : null}
				<nav class="navbar navbar-light light-blue lighten-4 project-quote-collapse-header must-be-relative">
					<a class="navbar-brand" href="#">
						<h1 class="project-quote-header">
							<Translated section="Quote" label="page_title" />
						</h1>
					</a>

					<button
						class="navbar-toggler toggler-example quote-whole-nav-toggle"
						type="button"
						data-toggle="collapse"
						data-target="#navbarSupportedContent-project-quote"
						aria-controls="navbarSupportedContent-project-quote"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span class="dark-blue-text project-quote-hamburger-icon">
							<i class="fas fa-bars fa-1x" />
						</span>
					</button>

					<div class="collapse navbar-collapse" id="navbarSupportedContent-project-quote">
						<ul class="navbar-nav mr-auto project-quote-list">
							<li class="nav-item">
								<DialogFollowup projectId={this.props.projectId} />
							</li>
							{!this.props.actingAgent ? (
								<li class="nav-item">
									<div class="quote-nav-component">
										<NavLink
											type="link"
											class="quote-nav-top-link"
											to={"/negotiations"}
										>
											<div></div>
											<div>
												<Translated
													section="Quote"
													label="sub_nav_negotiations"
												/>
											</div>
										</NavLink>
									</div>
								</li>
							) : (
								""
							)}
							<li class="nav-item">
								<div class="quote-nav-component">
									<a
										class="quote-nav-top-link"
										href="#"
										onClick={() =>
											this.setState(state => ({
												options: {
													...state.options,
													active: !state.options.active
												}
											}))
										}
									>
										<div></div>
										<div>
											<Translated section="Misc" label="options_label" />
										</div>
									</a>
								</div>
							</li>
							<li class="nav-item">
								<DialogEmailQuote
									language={this.props.selected_language}
								></DialogEmailQuote>
							</li>
							<li class="nav-item">
								<DialogEmailSpecList
									language={this.props.selected_language}
								></DialogEmailSpecList>
							</li>
							<li class="nav-item">
								<PrintForm
									language={this.props.selected_language}
								></PrintForm>
							</li>
							<li class="nav-item">
								<DialogEmailPictureBook
									language={this.props.selected_language}
								></DialogEmailPictureBook>
							</li>
							<li class="nav-item">
								<DialogTransferOrder
									successCall={this.transferSuccess}
									notInWarehouseProduct={this.state.notInWarehouseProduct}
									toggleNotInWarehouseStatus={this.toggleNotInWarehouseStatus}
								></DialogTransferOrder>
							</li>
						</ul>
					</div>
				</nav>

				<DragDropContext onDragEnd={this.rearrangeProducts}>
					<div class="quote-table-wrapper">
						<table class="quote-table">
							<thead class="quote-table-header">
								<tr>
									<th class="drag-col"></th>
									<th class="title-col">
										<Translated section="Quote" label="product_heading" />
									</th>
									<th class="note-col">
										<Translated section="Quote" label="notes_heading" />
									</th>
									<th class="quantity-col">
										<Translated section="Quote" label="quantity_heading" />
									</th>
									<th class="unit-col">
										<Translated section="Quote" label="unit_price_heading" />
									</th>
									<th class="allowance-col">
										<Translated section="Quote" label="allowances_heading" />
									</th>
									<th class="total-col">
										<Translated section="Quote" label="unit_total_heading" />
									</th>
									<th class="delete-col">
										<DialogDelete
											products={state.deletions}
											deleteRows={this.deleteRows}
										/>
									</th>
									<th class="update-col">
										<button onClick={() => this.hide_all_rooms()}>
											{translator("Quote", "collapse_expand")}
										</button>
									</th>
								</tr>
							</thead>
							{/* the reason we are using state.room_v2 because that has the correct order of rooms based on how you sorted it in project set up page */}
							{state.rooms_v2.map(roomv2 => {
								let room_id = roomv2.id;
								let room = state.rooms[room_id];
								return (
									<Droppable droppableId={room_id}>
										{(provided, snapshot) => (
											<tbody
												ref={provided.innerRef}
												{...provided.droppableProps}
												className={
													snapshot.isDraggingOver ? "tbody-space" : ""
												}
											>
												<tr class="quote-table-room-row" data-id={room_id}>
													<td class="drag-col"></td>
													<td class="title-col">{room.title}</td>
													<td class="note-col"></td>
													<td class="quantity-col">
														{this.getRoomQuantity(room_id)}
													</td>
													<td class="unit-col"></td>
													<td class="allowance-col"></td>
													<td class="total-col">
														{priceFormat.format(
															this.getRoomTotal(room_id)
														)}
													</td>
													<td class="delete-col"></td>
													<td class="update-col">
														<button
															class="collapse-button"
															onClick={this.hideRoom}
														>
															&#9660;
														</button>
													</td>
												</tr>
												{roomv2.products.map((room_product_id, index) => {
													let item = state.products[room_product_id];
													let productClass = "quote-table-product-row";
													if (room.hide)
														productClass += " collapse-product";
													if (item.changed_price || item.changed_quantity || item.changed_description || item.changed_note)
														productClass += " row-changed";
													return (
														<Draggable
															key={room_product_id}
															draggableId={room_product_id}
															index={index}
														>
															{(provided, snapshot) => (
																<tr
																	className={productClass}
																	data-id={room_product_id}
																	data-sku={
																		!!item.info.non_stock_model
																			? item.info
																					.non_stock_model
																			: item.sku
																	}
																	ref={provided.innerRef}
																	{...provided.draggableProps}
																	{...provided.dragHandleProps}
																>
																	<td class="drag-col">
																		<i class="fas fa-sort fa-2x" />
																	</td>
																	<td class="title-col">
																		<div class="quote-product-wrapper">
																			<div>
																				<input
																					type="text"
																					value={
																						item.input.description[this.props.selected_language]
																					}
																					onChange={
																						this.changeDescription
																					}
																				/>
																			</div>
																			<div>
																				{!!item.info
																					.non_stock_model ? (
																					<span class="non-stock-badge">
																						NS
																					</span>
																				) : (
																					""
																				)}
																				{!!item.nw ? (
																					<span class="not-in-warehouse-badge">
																						NW
																					</span>
																				) : (
																					""
																				)}
																				{!!item.ex ? (
																					<span class="manual-price-badge">
																						EX
																					</span>
																				) : (
																					""
																				)}
																				{item.sku}
																			</div>
																			{item.info.info && (
																				<DialogProductDetails
																					product={item.info.info}
																					projectId={this.props.projectId}
																					userFiles={state.userFiles[item.sku] || {}}
																					updateUserFile={this.updateUserFile}
																					hideModelNumber={checkSettings("hide_model_number")}
																					hideStandardPricing={checkSettings("hide_standard_pricing")}
																				/>
																			)}
																			{item.info.non_stock_title && (
																				<DialogProductDetails
																					product={item.info}
																					projectId={this.props.projectId}
																					updateNonStock={this.setProductsAndRooms}
																				/>
																			)}
																		</div>
																	</td>
																	<td class="note-col">
																		<input
																			type="text"
																			value={item.input.note}
																			onChange={this.changeNote}
																		/>
																	</td>
																	<td class="quantity-col">
																		<input
																			type="number"
																			min="0"
																			step="1"
																			value={
																				item.input.quantity
																			}
																			onKeyDown={e => this.checkIfBlockedChar(e, 'qty')}
																			onChange={
																				this.changeQuantity
																			}
																		/>
																	</td>
																	<td class="unit-col">
																		{item.info.is_standard
																			? (checkSettings("hide_standard_pricing") 
																				? translator("Quote Print", "standard_label") 
																				: priceFormat.format(
																					this.roundNumber(
																						item.input
																							.price,
																						2
																					)
																				)
																			)
																			: (
																				<>
																					<span class="col-unit">
																						$
																					</span>
																					<input
																						type="number"
																						value={
																							item.input
																								.price
																						}
																						min="0"
																						step="0.01"
																						onKeyPress={this.checkIfBlockedChar}
																						onChange={
																							this
																								.changePrice
																						}
																					/>
																				</>
																			)
																		}
																	</td>
																	<td class="allowance-col">
																		{priceFormat.format(
																			this.roundNumber(
																				item.info
																					.allowance_amount,
																				2
																			)
																		)}
																	</td>
																	<td class="total-col">
																		{item.info.is_standard
																			? "$0.00"
																			: priceFormat.format(
																					this.getUnitTotal(
																						room_product_id
																					)
																			  )}
																	</td>
																	<td class="delete-col">
																		<input
																			type="checkbox"
																			id={
																				"delete" +
																				room_product_id
																			}
																			checked={
																				state.deletions.hasOwnProperty(
																					room_product_id
																				)
																					? 1
																					: 0
																			}
																			onChange={
																				this.toggleDelete
																			}
																		/>
																		<label
																			for={
																				"delete" +
																				room_product_id
																			}
																		>
																			&#10005;
																		</label>
																	</td>
																	<td class="update-col">
																		<button
																			class="quote-table-update-button"
																			onClick={
																				this.saveProduct
																			}
																			disabled={
																				!item.changed_price &&
																				!item.changed_quantity &&
																				!item.changed_note &&
																				!item.changed_description
																			}
																		>
																			<Translated
																				section="Misc"
																				label="update_label"
																			/>
																		</button>
																	</td>
																</tr>
															)}
														</Draggable>
													);
												})}
											</tbody>
										)}
									</Droppable>
								);
							})}
							<tbody class="quote-table-footer">
								<tr class="quote-table-material-total">
									<td class="drag-col"></td>
									<td class="title-col"></td>
									<td class="note-col cell-label">
										<Translated section="Quote" label="quantity_heading" />:
									</td>
									<td class="quantity-col">{this.getProjectQuantity()}</td>
									<td class="cell-label" colspan="2">
										<Translated section="Quote" label="material_total_label" />:
									</td>
									<td class="total-col">
										{priceFormat.format(this.getMaterialTotal())}
									</td>
									<td class="delete-col"></td>
									<td class="update-col"></td>
								</tr>
								{state.options.active && (
									<tr className={optionsClass}>
										<td class="cell-label" colspan="4">
											<div class="options-wrapper">
												<div class="options-title">
													<Translated
														section="Quote"
														label="options_label"
													/>
												</div>
												<Toggle
													id="options-toggle"
													className={"options-toggle"}
													icons={{
														checked: (
															<span class="options-icon">%</span>
														),
														unchecked: (
															<span class="options-icon">$</span>
														)
													}}
													checked={state.options.input.isPercent}
													data-key="isPercent"
													onChange={this.changeOptions}
												/>
											</div>
										</td>
										<td class="unit-col">
											<input
												type="number"
												value={state.options.input.value}
												data-key="value"
												onChange={this.changeOptions}
											/>
										</td>
										<td class="allowance-col"></td>
										<td class="total-col"></td>
										<td class="delete-col">
											<button
												class="clear-options"
												onClick={this.clearOptions}
											>
												&#10005;
											</button>
										</td>
										<td class="update-col">
											<button
												class="quote-table-update-button"
												onClick={this.saveOptions}
												disabled={!state.options.changed}
											>
												<Translated section="Quote" label="update_btn" />
											</button>
										</td>
									</tr>
								)}
								{!!this.state.project_allowance && (
									<tr class="quote-table-total">
										<td class="drag-col"></td>
										<td class="title-col"></td>
										<td class="note-col"></td>
										<td class="quantity-col"></td>
										<td class="cell-label" colspan="2">
											<Translated
												section="Quote Print"
												label="project_allowance_label"
											/>
											:
										</td>
										<td class="total-col">
											{priceFormat.format(this.state.project_allowance)}
										</td>
										<td class="delete-col"></td>
										<td class="update-col"></td>
									</tr>
								)}
								<tr class="quote-table-total">
									<td class="drag-col"></td>
									<td class="title-col"></td>
									<td class="note-col"></td>
									<td class="quantity-col"></td>
									<td class="cell-label" colspan="2">
										<Translated section="Quote" label="total_heading" />:
									</td>
									<td class="total-col">
										{priceFormat.format(this.getProjectTotal())}
									</td>
									<td class="delete-col"></td>
									<td class="update-col"></td>
								</tr>
							</tbody>
						</table>
						{this.state.dialog}
					</div>
				</DragDropContext>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	projectId: state.projectIdUsedToIncreaseProductQuantity,
	projectWarehouseNumber: state.warehouseNumber,
	accountId: state.accountIdForTheProjectYouAreShoppingFor,
	actingAgent: state.isThisProjectActingAsAnAgent,
	warehouse_number_for_product_shopping_nav_bar_test: state.selected_project_warehouse_number_for_product_shopping_nav_bar_link,
	selected_language: state.selected_language,
	details_updated: state.details_updated,
});
const mapDispatchToProps = dispatch => {
	return {
		displayCheckPricesButtonOnNavBar: displayOrNot =>
			dispatch({
				type: actionTypes.DISPLAY_CHECK_PRICES_BUTTON_ON_NAV_BAR,
				displayOrNot
			}),
		displayProductShoppingButtonOnNavBar: (
			displayOrNot,
			selected_project_warehouse_number = "warehouse_number_has_not_been_provided_for_this_project"
		) =>
			dispatch({
				type: actionTypes.DISPLAY_PRODUCT_SHOPPING_BUTTON_ON_NAV_BAR,
				displayOrNot,
				selected_project_warehouse_number
			}),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectQuote);
